import React from 'react';
import { SegmentedControl } from './SegmentedControl';
import { callSources } from '../../data/callSources';
import { sourceTone } from '../../utils/sources';
import type { CallSource } from '../../types/voip';
interface SourceFilterProps<T extends CallSource> {
  value: T;
  onChange: (source: T) => void;
  /** Limit the picker to these sources (defaults to all) */
  include?: T[];
}
export function SourceFilter<T extends CallSource = CallSource>({
  value,
  onChange,
  include
}: SourceFilterProps<T>) {
  const options = callSources.filter(s => !include || include.includes(s.id as T)).map(s => ({
    value: s.id as T,
    label: s.label,
    dot: sourceTone[s.id].dot
  }));
  return <SegmentedControl label="Call source" options={options} value={value} onChange={onChange} data-id="element-143" data-mp="1qs941dx6bk4c" />;
}